import { render, staticRenderFns } from "./quoteDetailProduct.vue?vue&type=template&id=2db4ec84&scoped=true"
import script from "./quoteDetailProduct.vue?vue&type=script&lang=js"
export * from "./quoteDetailProduct.vue?vue&type=script&lang=js"
import style0 from "./quoteDetailProduct.vue?vue&type=style&index=0&id=2db4ec84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db4ec84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db4ec84')) {
      api.createRecord('2db4ec84', component.options)
    } else {
      api.reload('2db4ec84', component.options)
    }
    module.hot.accept("./quoteDetailProduct.vue?vue&type=template&id=2db4ec84&scoped=true", function () {
      api.rerender('2db4ec84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/inquiry/components/quoteDetailProduct.vue"
export default component.exports